export default "__VITE_ASSET__fb1b4ef1__"